exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{.notprint{display:none}body{-webkit-print-color-adjust:exact;font-family:SimSun,Microsoft YaHei;display:inline-block;overflow-y:auto;height:auto}.pagenext{page-break-after:always}.recordBox{background:#fff;width:199mm;height:auto;padding:1mm;margin:0;-webkit-box-shadow:none;box-shadow:none;border:none;font-size:3.39mm}.item-title{background-color:#f2f2f2;text-align:center;height:8mm;line-height:8mm;border-top:.1mm solid #000}td,th{font-size:3.39mm;line-height:1;color:#000}.mt-12{margin-top:1mm}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/patDlyRecord.vue
// module id = WSoW
// module chunks = 0